'use client';
import { PromotionBanner2 } from 'components/promotionBanner2/PromotionBanner2';
import './MarqueeBanner.css';

interface MarqueeBannerProps {
  text: string;
  heading: string;
  policy: string;
  sourceKey: string;
  phoneSourceKey: string;
}

export function MarqueeBanner(props: MarqueeBannerProps) {
  const { text, heading, policy, sourceKey, phoneSourceKey } = props;
  return (
    <>
        <div className="!fixed z-20 flex w-full flex-row overflow-hidden bg-fp-green shadow-sm">
          <div className="container mx-auto flex w-full flex-row gap-2">
            <div className="flex flex-1 items-center overflow-hidden">
              <div className="marquee-content text-nowrap">
                {!!text && (
                  <p className="text-white">{text}</p>
                )}
              </div>
            </div>
            <div className="flex flex-1/2 items-center">
              <PromotionBanner2
                heading={heading}
                policy={policy}
                sourceKey={sourceKey}
                phoneSourceKey={phoneSourceKey}
              />
            </div>
        </div>
      </div>
    </>
  );
}
